import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = ["placeholder"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "dt__search-loupe",
  width: "17",
  height: "15",
  viewBox: "0 0 17 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.1149 9.69528C11.9371 8.87991 12.4463 7.74942 12.4463 6.5C12.4463 4.01472 10.4316 2 7.94629 2C5.46101 2 3.44629 4.01472 3.44629 6.5C3.44629 8.98528 5.46101 11 7.94629 11C9.18215 11 10.3016 10.5018 11.1149 9.69528ZM11.1149 9.69528L15.4463 14",
    stroke: "#CCCCCC",
    "stroke-width": "2",
    "stroke-linecap": "round"
  })
], -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  width: "1.99646",
  height: "14.9734",
  rx: "0.998228",
  transform: "matrix(0.707087 -0.707126 0.707087 0.707126 0 1.41162)",
  fill: "#CCCCCC"
}, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  width: "1.99646",
  height: "14.9734",
  rx: "0.998228",
  transform: "matrix(0.707087 0.707127 -0.707087 0.707126 10.5879 0)",
  fill: "#CCCCCC"
}, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "dt__search-result" }
const _hoisted_7 = {
  key: 0,
  class: "dt__search-result-result"
}
const _hoisted_8 = {
  key: 0,
  class: "dt__search-res ult-result-wrapper"
}
const _hoisted_9 = { class: "dt__search-result-result-head" }
const _hoisted_10 = { class: "dt__search-result-result-content" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 1,
  class: "dt__search-result-result-wrapper"
}
const _hoisted_13 = { class: "dt__search-result-result-head" }
const _hoisted_14 = { class: "dt__search-result-result-content" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 0,
  class: "dt__search-result-result-content-item-child"
}
const _hoisted_18 = {
  key: 1,
  class: "dt__search-result-empty"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Ничего не найдено", -1 /* HOISTED */)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "dt-iconSearch" }, null, -1 /* HOISTED */)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "dt__search",
    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (this.search && this.search(...args)))
  }, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.searchText) = $event)),
      class: "dt__search-input",
      placeholder: this.placeholder,
      ref: "search",
      onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => ($options.onEnter && $options.onEnter(...args)), ["enter"])),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (this.$emit('openSearch')))
    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1), [
      [
        _vModelText,
        this.searchText,
        void 0,
        { trim: true }
      ]
    ]),
    _hoisted_2,
    _withDirectives((_openBlock(), _createElementBlock("svg", {
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.onClearSearch && $options.onClearSearch(...args))),
      class: "dt__search-close",
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, _hoisted_5, 512 /* NEED_PATCH */)), [
      [_vShow, this.searchText.length > 0]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      (this.searchResult.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (this.resultValueCategory.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createTextVNode(" Категории  "),
                    _createElementVNode("span", null, _toDisplayString(this.resultValueCategory.length), 1 /* TEXT */)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.resultValueCategory, (item) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_router_link, {
                        to: item.entity.getUrl(),
                        class: "dt__search-result-result-content-item"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            innerHTML: $options.textToHighlightHtml(item.entity)
                          }, null, 8 /* PROPS */, _hoisted_11)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true),
            (this.resultValuePage.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createTextVNode(" Разделы  "),
                    _createElementVNode("span", null, _toDisplayString(this.resultValuePage.length), 1 /* TEXT */)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.resultValuePage, (item) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("a", {
                        onClick: ($event: any) => ($options.onRouteToEntity(item.entity)),
                        class: "dt__search-result-result-content-item",
                        tabindex: "1"
                      }, [
                        _createElementVNode("span", {
                          innerHTML: $options.textToHighlightHtml(item.entity)
                        }, null, 8 /* PROPS */, _hoisted_16),
                        (item.parent)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(item.parent.name), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ], 8 /* PROPS */, _hoisted_15)
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21))
    ], 512 /* NEED_PATCH */), [
      [_vShow, this.visibleResult]
    ])
  ])), [
    [_directive_click_away, $options.onClickAway]
  ])
}